// extracted by mini-css-extract-plugin
export var compactFilters = "_bx-4";
export var detailImage = "_bx-1";
export var dropdownContainer = "_bx-2";
export var imageContainer = "_bx-0";
export var selectedCard = "_bx-3";